import { createBrowserRouter } from "react-router-dom";
import HomePage from "../pages/HomePage";
import MeetingPage from "../pages/MeetingPage";
import NotFoundPage from "../pages/NotFoundPage";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/session",
    element: <MeetingPage />,
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
]);
